<template>
    <div v-if="hasUserAccount">
      <login-form
        :email="email"
        :password="password"
        :has-user-account="hasUserAccount"
        :form-error="error"
        :success-message="successMessage"
        :provider-data="providerData"
        :login-loading="loginLoading"
        @input:email="email = $event"
        @input:password="password = $event"
        @has-user-account="$emit('has-user-account', $event)"
        @login="login">
      </login-form>
    </div>

    <div v-else class="app login app-register-grid">
      <div class="login-container is-small">
        <div class="login__logo-wrapper">
          <img
            :src="logoUrl"
            :alt="companyName">
        </div>

        <register-form
          :name="name"
          :email="email"
          :password="password"
          :has-user-account="hasUserAccount"
          :form-error="error"
          :success-message="successMessage"
          @input:name="name = $event"
          @input:email="email = $event"
          @input:password="password = $event"
          @has-user-account="$emit('has-user-account', $event)"
          @register="register">
        </register-form>

        <div class="register_footer-nav">
          <div class="register_footer-nav-links">
            <a href="/imprint">
              {{ $t('shirtigo.login.footer_nav.imprint') }}
            </a>
            <a href="/agb">
              {{ $t('shirtigo.login.footer_nav.agb') }}
            </a>
            <a href="/privacy">
              {{ $t('shirtigo.login.footer_nav.privacy') }}
            </a>
            <a href="/agb#widerrufsrecht">
              {{ $t('shirtigo.login.footer_nav.withdrawal') }}
            </a>
          </div>
        </div>

      </div>

      <div class="register_right-wrapper">
        <a href="javascript:void(0)" class="stoerer_component">
          <div class="div-block-2">
            <div class="heading-style-h5">
              <span class="heading-style-h3">100</span>€
            </div>
          </div>
          <div class="text-weight-semibold">{{ $t('shirtigo.login.slider.head_text') }}</div>
        </a>
        <div class="register_slider w-slider">
          <VueSlickCarousel :slidesToShow="1" :slidesToScroll="1" :fade="true" :autoplay="true" :autoplaySpeed="3000" :arrows="false" :dots="true">
            <div class="register_slider-slide w-slide">
                <div class="hero-container is-wide register_image-wrapper"
                  :style="`background-image: radial-gradient(circle at 50% 0, #0000 50%, #0f1626e6), url(${bgImageUrl})`">
                  <div class="login__hero-message">
                    <h2 class="title">
                      {{ $t('shirtigo.login.slider.title1') }}
                    </h2>
                    <p>{{ $t('shirtigo.login.slider.sub_title1') }}</p>
                  </div>
                </div>
            </div>
            <div class="register_slider-slide w-slide">
                <div class="hero-container is-wide register_image-wrapper"
                  :style="`background-image: radial-gradient(circle at 50% 0, #0000 50%, #0f1626e6), url(${bgImageUrl})`">
                  <div class="login__hero-message">
                    <h2 class="title">{{ $t('shirtigo.login.slider.title2') }}</h2>
                    <p>{{ $t('shirtigo.login.slider.sub_title2') }}</p>
                  </div>
                </div>
            </div>
            <div class="register_slider-slide w-slide">
                <div class="hero-container is-wide register_image-wrapper"
                  :style="`background-image: radial-gradient(circle at 50% 0, #0000 50%, #0f1626e6), url(${bgImageUrl})`">
                  <div class="login__hero-message">
                    <h2 class="title">{{ $t('shirtigo.login.slider.title3') }}</h2>
                    <p>{{ $t('shirtigo.login.slider.sub_title3') }}</p>
                  </div>
                </div>
            </div>
            <div class="register_slider-slide w-slide">
                <div class="hero-container is-wide register_image-wrapper"
                  :style="`background-image: radial-gradient(circle at 50% 0, #0000 50%, #0f1626e6), url(${bgImageUrl})`">
                  <div class="login__hero-message">
                    <h2 class="title">{{ $t('shirtigo.login.slider.title4') }}</h2>
                    <p>{{ $t('shirtigo.login.slider.sub_title4') }}</p>
                  </div>
                </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  import LoginForm from 'sb/modules/Auth/LoginForm.vue'
  import RegisterForm from 'sb/modules/Auth/RegisterForm.vue'

  export default {

    props: {
      error: {
        type: [String, Object],
        default: () => ({}),
      },
      successMessage: {
        type: String,
        default: null,
      },
      bgImageUrl: {
        type: String,
        default: '/images/login-image-1.jpg'
      },
      hasUserAccount: {
        type: Boolean,
        default: true
      },
      providerData: {
        type: Object,
        default: () => ({})
      },
      loginLoading: Boolean
    },

    data() {
      return {
        name: '',
        email: '',
        password: '',
        strengthLevel: 0,
        show: false,
      }
  },

  computed: {
    logoUrl() {
      return (this.providerData && this.providerData.logo) || '/images/shirtigo-id-logo-color.svg'
    },
    companyName() {
      return (this.providerData && this.providerData.company_name) || 'Shirtigo ID'
    }
  },

  methods: {

      login() {
        this.$emit('login', { email: this.email, password: this.password })
      },
      register() {
        this.$emit('register', { name: this.name, email: this.email, password: this.password })
      },
      buildUrl(path) {
        let url = new URL(path, location.origin)
        url.search = new URLSearchParams(location.search)
        return url
      }
    },

    components: {
      LoginForm,
      RegisterForm,
      VueSlickCarousel,
    },

  }
</script>

<style lang="scss" scoped>
  @import "~sb_sass/variables";
  @import "~sb_sass/mixins";

  .register_right-wrapper {
    padding-top: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
    position: relative;
    height: 100%;
    display: flex;

    .register_slider {
      border-radius: 16px;
      overflow: hidden;
      height: 100%;
      flex: 1;
      position: relative;

      .slick-slider {
        height: 100%;
      }
    }

    :deep(.slick-slider),
    :deep(.slick-list),
    :deep(.slick-track) {
      height: 100% !important;
    }

    :deep(.slick-slide) {
      height: 100% !important;
      > div {
        height: 100% !important;
      }
    }

    :deep(.slick-dots) {
      bottom: 40px !important;
      width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;

      li {
        width: 10px !important;
        height: 10px !important;
        margin: 0 3px !important;
        padding: 0 !important;

        button {
          width: 10px !important;
          height: 10px !important;
          padding: 0 !important;
          background: rgba(255, 255, 255, 0.4) !important;
          border-radius: 100% !important;

          &::before {
            display: none !important;
          }
        }

        &.slick-active {
          button {
            background-color: #fff !important;
          }
        }
      }
    }

    .register_slider-slide {
      height: 100%;
    }

    .register_image-wrapper {
      background-position: 0 0, 50%;
      background-size: auto, cover;
      flex-flow: column;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
      padding-bottom: 6rem;
      padding-left: 1rem;
      padding-right: 1rem;
      display: flex;
    }

    .login__hero-message {
      .title {
        color: $white;
        font-size: 48px;
        margin-top: 0px;
        margin-bottom: 16px;
        padding-top: 0px;
        padding-bottom: 0px;
        font-weight: 900;
        line-height: 1.2;
        text-align: center;
      }
      p {
        color: $white;
        font-weight: 400;
        font-size: 18px;
        margin-top: 0px;
        margin-bottom: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        line-height: 1.6;
        text-align: center;
      }
    }

    .stoerer_component {
      z-index: 9;
      color: #152340;
      text-align: center;
      background-color: #f9df75;
      border-radius: 50%;
      flex-flow: column;
      flex: none;
      justify-content: center;
      align-items: center;
      width: 9rem;
      height: 9rem;
      padding: 1rem;
      font-size: 1rem;
      line-height: 1.4;
      display: flex;
      position: absolute;
      inset: 4rem auto auto 3rem;
      cursor: pointer;
      transform-style: preserve-3d;
      transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-15deg) skew(0deg);
      transition: transform 0.2s ease;
      .div-block-2 {
        grid-column-gap: .25rem;
        grid-row-gap: .25rem;
        align-items: baseline;
        display: flex;
        .heading-style-h5 {
          color: #152340;
          font-size: 16px;
          font-weight: 700;
          line-height: 1.5;
          text-align: center;
          .heading-style-h3 {
            font-size: 32px;
            font-weight: 800;
            line-height: 1.2;
          }
        }
      }
      .text-weight-semibold {
        font-weight: 600;
      }
      &:hover {
        transform: translate3d(0px, 0px, 0px) scale3d(1.1, 1.1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-25deg) skew(0deg);
      }
    }

  }

  .register_footer-nav {
    max-width: 559px;
    margin: 16px auto 32px auto;
    width: 100%;
    .register_footer-nav-links {
      grid-column-gap: 16px;
      grid-row-gap: 16px;
      font-size: var(--text-size--xsmall);
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      display: flex;
      a {
        color: #64748b;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.6;
        text-decoration: none;
      }
    }
  }

  .app-register-grid {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    width: 100%;
    /*height: 100vh;*/
    background-color: #f8fafc;

    .w-full {
      width: 100%;
    }

    .login-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }

    .login__logo-wrapper {
      width: 192px;
      min-width: 192px;
      position: absolute;
      top: 24px;
      left: 24px;
    }

  }

  @media screen and (max-width: 991px) {
    .register_right-wrapper {
      display: none;
    }
    .app-register-grid  {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      .login__logo-wrapper {
        margin: 4rem auto;
        position: static;
        left: auto;
        top: auto;
      }
      .form-wrapper {
        margin: 0px;
      }
      .register_footer-nav {
        margin: 4rem auto 2rem auto;
        .register_footer-nav-links {
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .spacer-large {
      padding-top: 24px;
    }
    .app-register-grid {
      .login-container {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
      }
      .form-wrapper {
        h3 {
          font-size: 24px;
        }
        .login-text {
          flex-wrap: wrap;
        }
      }
      .login__logo-wrapper {
        margin-top: 3rem;
        margin-bottom: 3rem;
        min-width: 160px;
        max-width: 160px;
      }
    }
  }
</style>
